import React from 'react';
import { View } from 'react-native';

import OPPureComponent from './op_pure_component';
import { COLOR } from '../../constants/styles';

class ProgressIndicator extends OPPureComponent {
  render() {
    let { style, width, progress, backgroundColor, fillColor, height } = this.props;
    height = height || 10;
    backgroundColor = backgroundColor || COLOR.accent;
    fillColor = fillColor || COLOR.emphasis;
    return (
      <View
        style={{
          ...style,
          backgroundColor,
          flexDirection: 'row',
          width,
          height,
          borderRadius: height,
          overflow: 'hidden',
        }}
      >
        <View
          style={{
            height,
            borderRadius: height,
            flex: progress,
            backgroundColor: fillColor,
          }}
        />
      </View>
    );
  }
}

export default ProgressIndicator;
